import * as tslib_1 from "tslib";
import { v4 as uuid } from 'uuid';
var MembershipQuestions = /** @class */ (function () {
    function MembershipQuestions() {
        this.questions = new Map();
    }
    MembershipQuestions.prototype.getQuestions = function () {
        return Array.from(this.questions.values());
    };
    MembershipQuestions.prototype.setQuestions = function (questions) {
        this.questions = questions.reduce(function (qMap, q) {
            qMap.set(q.questionId, q);
            return qMap;
        }, new Map());
    };
    MembershipQuestions.prototype.getById = function (id) {
        return this.questions.get(id);
    };
    MembershipQuestions.prototype.create = function () {
        var questionId = uuid();
        this.questions.set(questionId, { questionId: questionId });
        return questionId;
    };
    MembershipQuestions.prototype.update = function (question) {
        this.questions.set(question.questionId, question);
    };
    MembershipQuestions.prototype.remove = function (question) {
        this.questions.delete(question.questionId);
    };
    MembershipQuestions.prototype.validate = function (question) {
        return tslib_1.__assign({}, question, { invalid: !question.textQuestion });
    };
    return MembershipQuestions;
}());
export { MembershipQuestions };
//# sourceMappingURL=MembershipQuestions.js.map